export function compileDictionaryItem(
  key: string,
  compiledValue: string
): string {
  return `"${key}": ${compiledValue}`;
}
